export default {
  analytics: {
    viewTitle: {
      analytics: "Analytics",
      newReport: "New Report",
      editReport: "Edit Report",
    },
    tabTitle: {
      analytics: "Analytics_一覧",
      newReport: "Analytics_作成",
      editReport: "Analytics_編集",
    },
    button: {
      create: "NEW REPORT",
      addFilter: "フィルタ追加",
      saveAndRun: "保存して実行",
      adhocRun: "保存せずに実行",
    },
    notify: {
      success: {
        delete: "レポートを削除しました",
        save: "レポートの保存に成功しました",
        download: "レポートのダウンロードに成功しました",
      },
      error: {
        delete: "レポートの削除に失敗しました",
        emptyStartDate: "開始日を入力してください",
        emptyEndDate: "終了日を入力してください",
        reverseDate: "開始日は終了日以前に設定してください",
        invalidAnalyticsStartDate: "開始日を2021年10月1日以降にしてください",
        limitAnalyticsPeriod: "期間を31日以内にしてください",
        invalidScrapingStartDate: "開始日を2019年04月1日以降にしてください",
        limitScrapingPeriod: "期間を過去1年間に絞ってください",
        invalidDevice: "BI_REPORT で選択できないフィルタが含まれています: デバイス",
        invalidBrowser: "BI_REPORT で選択できないフィルタが含まれています: ブラウザ",
        invalidOs: "BI_REPORT で選択できないフィルタが含まれています: OS",
        emptyDimension: "ディメンションを選択してください",
        emptyMetrics: "メトリクスを選択してください",
        validateError: "入力内容に誤りがあります",
        failedSave: "レポートの保存に失敗しました",
        failedSaveAndDownload: "レポートの保存に失敗しました.処理を中断します",
        failedGenerate: "レポート生成に失敗しました",
        failedDownload: "レポートのダウンロードに失敗しました。管理者にお問い合わせください。",
      },
    },
    tableHeader: {
      name: "レポート名",
      owner: "オーナー",
      reportType: "レポートタイプ",
      createdAt: "作成日",
    },
    tooltip: {
      nameSyntax: {
        limit: "200文字以内で入力してください",
        type: "日本語、英数字(半角全角問わず)、一部記号が入力可能です",
        halfSymbol: "半角記号は - _ () のみ入力可能です",
        fullSymbol:
          "全角記号は（）〔〕［］｛｝〈〉《》「」『』【】＿ー(のばし棒) ―(水平バー) ‐(ハイフン) ：のみ入力可能です",
        emoji: "絵文字はご利用できません",
      },
      timezone: "取得されるデータはUTC基準となります",
      clearBidder: "選択済みの入札者をすべてクリア",
      clearAdUnit: "選択済みの広告枠をすべてクリア",
      clearAdUnitGroup: "選択済みの広告枠グループをすべてクリア",
      clearDevice: "選択済みのデバイスをすべてクリア",
      clearBrowser: "選択済みのブラウザをすべてクリア",
      clearOs: "選択済みのOSをすべてクリア",
      clearDomain: "選択済みのドメインをすべてクリア",
      clearPublisher: "選択済みのパブリッシャーをすべてクリア",
      clearFilter: "すべてのフィルタをクリア",
      dragAndDrop:
        "選択済みの項目はドラッグ＆ドロップで順番を入れ替えることで<br>レポート出力時の表示順序を変更することができます",
      notAction: "レポート実行中のため、アクションを行うことができません",
      notSave: "他のユーザーが作成したレポートは保存できません",
    },
    text: {
      listMenu: {
        edit: "編集",
        delete: "削除",
      },
      deleteDialog: {
        title: "確認",
        text: "レポートを削除します",
      },
      title: "全般設定",
      reportName: "レポート名",
      period: "期間選択",
      startDate: "開始日",
      endDate: "終了日",
      filterCardTitle: "フィルタ設定",
      filter: "フィルタ",
      selectPublisher: "パブリッシャーを選択してください",
      selectedFilter: "選択済みのフィルタ",
      bidder: "入札者",
      adUnit: "広告枠",
      adUnitGroup: "広告枠グループ",
      device: "デバイス",
      browser: "ブラウザ",
      os: "OS",
      domain: "ドメイン",
      publisher: "パブリッシャー",
      noFilter: "フィルタが選択されていません",
      noFilterValue: "対象の項目がありません",
      searchReport: "レポートを検索",
      searchBidder: "入札者を検索",
      searchAdUnit: "広告枠を検索",
      searchAdUnitGroup: "広告枠グループを検索",
      searchDevice: "デバイスを検索",
      searchBrowser: "ブラウザを検索",
      searchOs: "OSを検索",
      searchDomain: "ドメインを検索",
      searchPublisher: "パブリッシャーを検索",
      reportType: {
        title: "レポートタイプ",
        prebidAnalyticsAnnotation:
          "Prebid Analyticsで計測するデータには、オークション発生時からImpressionまでが含まれますが、各SSP/DSP側で計測している確定値や、GoogleAdManagerのデータとの乖離が発生することをご留意ください。<br>無効トラフィック（IVT）やユーザー起因の通信エラーにより、計測数値が欠損する可能性があります。",
        gamTypeAnnotation:
          "GoogleAdManagerで計測するデータには、広告リクエスト発生時からImpressionまでが含まれますが、各SSP/DSP側で計測している確定値や、Prebid Analyticsのデータとの乖離が発生することをご留意ください。<br>無効トラフィック（IVT）やユーザー起因の通信エラーにより、計測数値が欠損する可能性があります。",
      },
      sortSelection: {
        dimension: "ディメンション",
        metrics: "メトリクス",
        category: "Category",
        value: "Value",
        selectedValue: "選択済み",
      },
      action: {
        title: "アクション",
      },
      reportTypeDialog: {
        title: "確認",
        text: "レポートタイプを変更した場合、編集した内容は失われます。よろしいですか？",
      },
      unAuthorizedDialog: {
        text: "許可されていない項目です。Analytics一覧へ移動します",
      },
      currency: "レポートダウンロード時には、右上の通貨切り替えボタンにて指定された通貨で数値が取得されます。",
    },
  },
};
